import { addVisible, removeVisible } from './helper';

const CLS = '.validate--tooltip-minlength';
export function validateMinLength(element: HTMLInputElement, minLen: number): boolean {
    if (element.value.length < minLen) {
        addVisible(element, CLS);
        return false;
    } else {
        removeVisible(element, CLS);
        return true;
    }
}
export function liveValidateMinLength(element: HTMLInputElement) {
    const minLen = parseInt(element.getAttribute('minlength') as string, 10);
    if (isNaN(minLen)) {
        return;
    }
    element.addEventListener('input', (e: Event) => {
        return validateMinLength(element, minLen);
    });
    element.addEventListener('change', (e: Event) => {
        return validateMinLength(element, minLen);
    });
    element.addEventListener('blur', (e: Event) => {
        return validateMinLength(element, minLen);
    });
}
